import type { List } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableServerError } from '@gonfalon/legacy-http-client/httpUtils';
import type { AnyAction } from 'redux';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { catchError, debounceTime, from, merge, mergeMap, of, switchMap } from 'rxjs';

import type { TagsAction } from '#actions/tags';
import { fetchTagsDone, fetchTagsFailed } from '#actions/tags';
import registry from '#epics/registry';
import { fetchTags } from '#sources/TagAPI';
import { DEBOUNCE_MS } from '#utils/inputUtils';

export function resolveTags(action$: Observable<AnyAction>) {
  return action$.pipe(
    ofType<TagsAction, 'tags/FETCH_TAGS'>('tags/FETCH_TAGS'),
    debounceTime(DEBOUNCE_MS),
    switchMap((action) => from(fetchTags(action.prefix || null, action.kind, action.archived))),
    mergeMap((response) => of(fetchTagsDone(response as List<string>))),
    catchError((error: ImmutableServerError, source) => merge(of(fetchTagsFailed(error)), source)),
  );
}

registry.addEpics([resolveTags]);
